import { render, staticRenderFns } from "./TemplateHeader.vue?vue&type=template&id=3edb5757"
import script from "./TemplateHeader.vue?vue&type=script&lang=ts"
export * from "./TemplateHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports